import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'

import { useParams } from 'next/navigation'
import {
  QUERY_POINT_EXPIRING_SUMMARY_KEY,
  fetchPointExpiringSummary,
} from './fetchPointExpiringSummary'
import useAuthentication from '../useAuthentication'
import type { PointExpirySummaryModel } from 'core/profile/types'

function useQueryPointExpiringSummary(): UseQueryResult<PointExpirySummaryModel | null> {
  const params = useParams<{ locale: string }>()
  const { locale } = params || {}
  const { isAuthenticated, withSmartclubApiRequest } = useAuthentication()

  return useQuery({
    queryKey: [QUERY_POINT_EXPIRING_SUMMARY_KEY, { locale }],
    queryFn: withSmartclubApiRequest(fetchPointExpiringSummary),
    enabled: isAuthenticated,
  })
}

export default useQueryPointExpiringSummary
